/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/**
 * A preset configuration for rate plans.
 *
 * @typedef {Object} RatePlanPreset
 * @property {Object} columns - Configuration for table columns.
 * @property {number[]} columns.width - Array of widths for each column, where the first two columns have widths of 25 and 40, and the next 16 columns have a width of 10.
 * @property {string} columns.end - Specifies the ending column, represented by the letter 'R'.
 * @property {Object} table - Configuration for the table.
 * @property {number} table.start - The starting index of the table.
 * @property {number} table.end - The ending index of the table.
 */

/**
 * A preset for the rate plan table layout, defining column widths and table boundaries.
 *
 * @type {RatePlanPreset}
 */
export const ratePlanPreset = {
  rows: {
    header: [11],
  },
  columns: {
    width: [25, 40, ...Array(16).fill(12)],
    end: 'R',
  },
  table: {
    start: 11,
    end: 31,
    dataStart: 12,
  },
  bordered: true,
  totalRow: false,
};

export default ratePlanPreset;
